import React from 'react';

import ArticleFilterPane from '../ArticleFilterPane/index.jsx';
import SearchField from '../Search/index.jsx';

import AjaxService from '../../Services/Ajax/index.jsx';


class ResearchReportsFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      filters: []
    };

    this.handleResponse = this.handleResponse.bind(this);
    this.onFetchChange = this.onFetchChange.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  fetchFilters() {
    AjaxService.fetch('theme:research-report-feed-filters')
      .then(this.handleResponse);
  }

  handleResponse(response) {
    if (response && response.length) {
      // default all filters to selected.
      for (var i = 0; i < response.length; i++) {
        response[i].value = true;
      }
    }

    this.setState({ filters: response });
  }

  onSearchChange(value) {
    value = value.trim();

    if (value) {
      this.props.api.updateSearchQuery(value);
    }
  }

  onFilterChange(type, filters) {
    this.setState({ filters: filters });

    // update the API service with the members new selection.
    var categories = [];
    for (var i = 0; i < filters.length; i++) {
      if (filters[i].value) {
        categories.push(filters[i].id);
      }
    }
    this.props.api.setCategories(categories);
  }

  onFetchChange(isFetching) {
    this.setState({ fetching: isFetching });
  }

  componentDidMount() {
    this.fetchFilters();

    if (this.props.api.addFetchListener) {
      this.props.api.addFetchListener(this.onFetchChange);
    }
  }

  componentWillUnmount() {
    if (this.props.api.removeFetchListener) {
      this.props.api.removeFetchListener(this.onFetchChange);
    }
  }

  render() {
    return (
      <React.Fragment>
        <ArticleFilterPane
          busy={this.state.fetching}
          onFilterChange={this.onFilterChange}
          filters={this.state.filters}
        />
        <SearchField
          isBusy={this.state.fetching}
          onChange={this.onSearchChange}
          placeholder="Search Research Reports"
        />
      </React.Fragment>
    );
  }
}


export default ResearchReportsFilters;

